/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_copied = /** @type {(inputs: {}) => string} */ () => {
	return `¡Copiado!`
};

const en_common_copied = /** @type {(inputs: {}) => string} */ () => {
	return `Copied!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_copied = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_copied(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_copied", locale)
	if (locale === "es") return es_common_copied(inputs)
	return en_common_copied(inputs)
};
export { common_copied as "common.copied" }